import { UrlConstants } from "../url.constants";
export class ApiAssemblyVersionConstants {
    static URL = UrlConstants.API_V2 + "AssemblyVersion";
}
